import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewChild  } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule, Table } from 'primeng/table';
import { ActivatedRoute, RouterLink, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { HttpClient } from '@angular/common/http';

/*----Prime NG----*/
import { InputTextModule } from 'primeng/inputtext';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { FormsModule } from "@angular/forms";

@Component({
  selector: 'app-contractlist-section',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule, TableModule, InputTextModule, InputIconModule, IconFieldModule, FormsModule],
  providers: [Base64UrlService],
  templateUrl: './contractlist-section.component.html',
  styleUrl: './contractlist-section.component.css'
})
export class ContractlistSectionComponent {
  companyId: any;
  @ViewChild('dt2') dt2: any;
  userName: any;
  lang: any;
  sectionList: any;
  userLogList: any;
  monthDropdown: any;
  userCode: any;
  selectedDate: any;
  dropDowndate: any;
  // These hold filtered data
  visibleData: any[] = [];
  totalCount: number = 0;
  timeSheetDate: string = '';
  constructor(private route: ActivatedRoute, private auth: AuthService, private translate: TranslateService, private ts: TimesheetService, private en: EncryptionService, private pageTitle: PageTitleService, private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {

      this.lang = (localStorage.getItem('site_lang') ? localStorage.getItem('site_lang') : 'en');
      // console.log(this.lang)
      translate.use(this.lang);
    }
  }
  
  ngOnInit() {
    this.userName = this.auth.getName();
    this.userCode = this.auth.getCode();
    this.companyId = this.en.decryptionAES(Base64UrlService.decode(this.route.snapshot.params['comId']));
    this.timeSheetDate = this.en.decryptionAES(Base64UrlService.decode(this.route.snapshot.params['time']));
    this.pageTitle.setTitle('menu.timesheet');
    if (isPlatformBrowser(this.platformId)) {
      this.getAssociates();
    }
  }

  getAssociates() {
    // this.ts.getMonthList()
    this.ts.getMonthListV2()
      .subscribe({
        next: (resMonthList: any) => {
          // this.monthDropdown = resMonthList.data.dates;
          this.monthDropdown = resMonthList.data;
          // console.log(this.monthDropdown);
          // const [day, month, year] = resMonthList.data.selectedDate.split('-');
          // let newFormat = `${year}-${month}-${day}`;
          const [year, month, day] = this.timeSheetDate.split('-');//resMonthList.data.selectedDate.split('-');
          let newFormat = this.timeSheetDate;//`${year}-${month}-${day}`;
          console.log(newFormat);
          this.selectedDate = newFormat;
          this.dropDowndate = `${day}-${month}-${year}`
          this.getAssociatesList();
          this.getUserLog();
        },
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout(); 
			return	
          }
        }
      });
  }

  getAssociatesList() {

    this.ts.getContractSummarySection(this.companyId, this.selectedDate)
      .subscribe({
        next: (res: any) => {
          // this.companyList = this.applyEncryption(res.data);
          this.sectionList = res.data;
          this.totalCount = this.sectionList.length;
          this.updateVisibleData();
        },
        error: (err: any) => {
          console.log(err);
          if (err.status == 401) {
            this.auth.logout();
			return
          }
        }
      });
  }

  getUserLog() {
    this.ts.getlogUserAction('4')
      .subscribe({
        next: (res: any) => {
          // this.companyList = this.applyEncryption(res.data);
          this.userLogList = res.data;
          this.userLogList = res.data.map((item: any) => {
            return {
              ...item,              
              procDetailsData: JSON.parse(item.procDetail),              
            };
          });
          this.updateVisibleData();
        },
        error: (err: any) => {
          console.log(err);
          if (err.status == 401) {
            this.auth.logout();
			return
          }
        }
      });
  }

  fncCng(event: any) {
    let dateFormat = this.getDateFromEvent(event);
    this.selectedDate = dateFormat;
    this.getAssociatesList();
  }

  createSingle(cmpId: any, date: any, sectionId: any) {
    this.ts.downloadContractListSingleAll(cmpId, date, sectionId)
      .subscribe({
        next: (res: any) => {
          // Create a blob from the response
          const blob = new Blob([res.body ?? res], { type: 'application/zip' });

          // Create a temporary download link
          const fileURL = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = fileURL;

          // Optional: derive filename from API or generate dynamically
          a.download = 'TimeSheetSummary_' + date + '.zip';

          // Trigger the download
          a.click();

          // Cleanup
          URL.revokeObjectURL(fileURL);
        },
        error: (err: any) => {
          console.error('Error downloading file:', err);
		  if (err.status == 401) {
			  this.auth.logout();
			  return
			}
        }
    })
  }

  private getDateFromEvent(event: any): string {
    if (!event) return '2025-07-01';
    const target = event.target as HTMLSelectElement;
    return this.getDate(target.value);
  }

  getDate(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    const yyyy = date.getFullYear();
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const dd = date.getDate().toString().padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }

  get totalUser() {
    return this.visibleData.reduce((sum:any, item: any) => sum + (item.resourceCount || 0), 0);    
  }

  formatSeconds(totalTime: number): string {
    const hours = Math.floor(totalTime / 3600);
    const minutes = Math.floor((totalTime % 3600) / 60);
    // const seconds = totalTime % 60;
    // :${ this.pad(seconds) }
    return `${hours}:${this.pad(minutes)}`;
  }

  pad(num: number): string {
    return num.toString().padStart(2, '0');
  }

  getSelectedMonth(dateStr: string): string {
    const [year, month, day] = dateStr.split('-').map(Number);
    const date = new Date(dateStr);    
    return date.toLocaleDateString('en-US', { month: 'long'});
  }

  getMonth(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { month: 'short'});
  }
  getYear(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { year: 'numeric'});
  }
  applyFilterGlobal($event: Event) {
    const input = $event.target as HTMLInputElement;
    this.dt2.filterGlobal(input.value, 'contains');
    // Table triggers onFilter after this
  }

  // Update filteredData whenever filter or pagination changes
  onFilter(event: any) {
    this.updateVisibleData();
  }

  onPage(event: any) {
    this.updateVisibleData(event);
  }

  onSort() {
    this.updateVisibleData();
  }

  updateVisibleData(event?: any) {
    const filtered = this.dt2.filteredValue ?? this.sectionList;
    const start = event?.first ?? this.dt2.first ?? 0;
    const rows = event?.rows ?? this.dt2.rows ?? 3;
    const end = start + rows;
    this.visibleData = filtered.slice(start, end);
  }
  
  onGlobalFilter(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.dt2.filterGlobal(value, 'contains');
  }

  applyEncryption(dt: any) {
    dt.forEach((elm: any, ind: any) => {
      dt[ind].timesheetID = Base64UrlService.encode(this.en.encryptionAES(elm.timesheetID.toString()))
    });
    return dt;
  }
  
}
